import React, { Component } from 'react';
import { Modal, PageHeader } from 'react-bootstrap';
import DateTimePicker from 'react-datetime-picker';
import { invokeApig } from '../libs/awsLib';
import './ViewStockingLogs.css';
import LoaderButton from '../components/LoaderButton';

/* TODO: rewrite for loops to prevent ESlint errors */
/* eslint-disable guard-for-in, no-restricted-syntax */
export default class ViewStockingLogs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertModal: {
        mode: false,
        text: '',
      },
      isLoading: false,
      usersList: [],
      fridgeList: [],
      logs: [],
      filteredLogs: [],
      startTime: '',
      endTime: '',
      selectedUser: '',
      selectedFridge: '',
    };
    this.getStockingLogs = this.getStockingLogs.bind(this);
    this.queryData = this.queryData.bind(this);
    this.formLogs = this.formLogs.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  async componentDidMount() {
    const resourcePath = `/reports/driverlog/cognitoemails`;
    try {
      const response = await invokeApig({
        path: resourcePath,
        method: 'GET',
      });
      const emails = response.body.emails;
      this.setState(
        {
          emails,
        },
        function () {
          const endTime = new Date();
          const startTime = new Date();
          startTime.setDate(endTime.getDate() - 1);
          this.setState({ startTime, endTime });
        },
      );
    } catch (e) {
      console.log(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // let errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load data, Please check your internet and your permissions';
      this.setState({ alertModal, isLoading: false });
    }
  }

  async queryData() {
    let alertModal;
    if (this.state.startTime === '' || this.state.endTime === '') {
      alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text = 'Start time or End time cannot be null';
      this.setState({ alertModal });
      return;
    }
    if (this.state.startTime >= this.state.endTime) {
      alertModal = this.state.alertModal;
      alertModal.mode = true;
      alertModal.text = 'Start time cannot be equal or greater than end time';
      this.setState({ alertModal });
      return;
    }
    const startTimeUtc = this.state.startTime.toUTCString();
    const endTimeUtc = this.state.endTime.toUTCString();
    const startTimeEpoch = new Date(startTimeUtc).getTime() / 1000;
    const endTimeEpoch = new Date(endTimeUtc).getTime() / 1000;
    this.getStockingLogs(startTimeEpoch, endTimeEpoch);
  }

  compare(a, b) {
    if (a.user > b.user) {
      return 1;
    }
    if (b.user > a.user) {
      return -1;
    }
    if (a.requestTime > b.requestTime) {
      return 1;
    }
    if (b.requestTime > a.requestTime) {
      return -1;
    }
    return 0;
  }

  handleFilterChange(event) {
    this.setState({ [event.target.name]: event.target.value }, () => {
      const filteredLogs = [];
      for (const i in this.state.logs) {
        let include = true;
        if (
          this.state.selectedUser === '' ||
          (this.state.selectedUser !== '' &&
            this.state.logs[i].user === this.state.selectedUser)
        ) {
          include = true;
        } else {
          include = false;
        }
        if (
          this.state.selectedFridge === '' ||
          (this.state.selectedFridge !== '' &&
            this.state.logs[i].fridge === this.state.selectedFridge)
        ) {
          include = include && true;
        } else {
          include = include && false;
        }
        if (include) {
          filteredLogs.push(this.state.logs[i]);
        }
      }
      this.setState({ filteredLogs });
    });
  }

  formLogs(logsFromServer) {
    const requestLogs = {};
    let requestId;
    let type;
    let thisDate;
    for (const i in logsFromServer) {
      if (logsFromServer[i].requestId in requestLogs) {
        requestId = logsFromServer[i].requestId;
        type = logsFromServer[i].type;
        requestLogs[requestId][type] = logsFromServer[i];
      } else {
        requestId = logsFromServer[i].requestId;
        type = logsFromServer[i].type;
        requestLogs[requestId] = {};
        requestLogs[requestId][type] = logsFromServer[i];
      }
    }
    const rows = [];
    for (requestId in requestLogs) {
      const temp = {
        requestId: ' ',
        requestTime: ' ',
        user: ' ',
        fridge: ' ',
        operation: ' ',
        responseTime: ' ',
        errorMessage: '',
        isError: false,
      };
      temp.requestId = requestId;
      if ('request' in requestLogs[requestId]) {
        thisDate = new Date(requestLogs[requestId].request.action_time * 1000);
        temp.requestTime = `${thisDate.toLocaleDateString(
          'en-US',
        )} ${thisDate.toLocaleTimeString('en-US', { hour12: false })}`;
        temp.user = this.state.emails[requestLogs[requestId].request.uuid];
        temp.fridge = requestLogs[requestId].request.fridge;
        temp.operation = requestLogs[requestId].request.operation;
      }
      if ('response' in requestLogs[requestId]) {
        thisDate = new Date(requestLogs[requestId].response.action_time * 1000);
        temp.responseTime = `${thisDate.toLocaleDateString(
          'en-US',
        )} ${thisDate.toLocaleTimeString('en-US', { hour12: false })}`;
      }
      if ('error' in requestLogs[requestId]) {
        thisDate = new Date(requestLogs[requestId].error.action_time * 1000);
        temp.responseTime = `${thisDate.toLocaleDateString(
          'en-US',
        )} ${thisDate.toLocaleTimeString('en-US', { hour12: false })}`;
        temp.errorMessage = 'Error while processing this request';
        temp.isError = true;
      }
      rows.push(temp);
      rows.sort(this.compare);
    }
    this.setState({ logs: rows, filteredLogs: rows });
  }

  async getStockingLogs(startTime, endTime) {
    this.setState({ isLoading: true });
    const resourcePath = `/reports/driverlog?startTime=${startTime}&endTime=${endTime}`;
    const usersList = new Set();
    const fridgeList = new Set();
    try {
      const response = await invokeApig({
        path: resourcePath,
        method: 'GET',
      });
      const logs = response.body;
      this.formLogs(logs);
      for (const i in logs) {
        if ('uuid' in logs[i]) {
          usersList.add(this.state.emails[logs[i].uuid]);
        }
        if ('fridge' in logs[i]) {
          fridgeList.add(logs[i].fridge);
        }
      }
      this.setState({
        isLoading: false,
        usersList: Array.from(usersList).sort(),
        fridgeList: Array.from(fridgeList).sort(),
        selectedUser: '',
        selectedFridge: '',
      });
    } catch (e) {
      console.log(e);
      const alertModal = this.state.alertModal;
      alertModal.mode = true;
      // let errorString = JSON.stringify(e);
      // var errorObject = JSON.parse(errorString);
      alertModal.text =
        'Unable to load data, Please check your internet and your permissions';
      this.setState({ alertModal, isLoading: false });
    }
  }

  generateRows(item, key) {
    return (
      <tr
        key={item.requestId}
        className={item.isError ? 'errorResponse' : null}
      >
        <td>{item.user}</td>
        <td>{item.fridge}</td>
        <td>{item.operation}</td>
        <td>{item.requestTime}</td>
        <td>{item.responseTime}</td>
        <td>{item.errorMessage}</td>
      </tr>
    );
  }

  render() {
    return (
      <div>
        <div id="alertBox">
          <Modal show={this.state.alertModal.mode}>
            <Modal.Body>
              <div className="form-group">{this.state.alertModal.text}</div>
            </Modal.Body>
            <Modal.Footer>
              &nbsp;
              <button
                type="button"
                className="btn modalButtons btn-warning"
                onClick={() => {
                  const alertModal = this.state.alertModal;
                  alertModal.mode = false;
                  this.setState({ alertModal });
                }}
              >
                Close
              </button>
            </Modal.Footer>
          </Modal>
        </div>
        <div className="stockingLogs">
          <PageHeader>Stocking Logs</PageHeader>
          <div className="row">
            <div className="col-sm-5 col-xs-12">
              <font size="5" color="Green">
                Filter From:{' '}
              </font>
              <DateTimePicker
                name="startTimePicker"
                onChange={(date) => this.setState({ startTime: date })}
                value={this.state.startTime}
              />
            </div>
            <div className="col-sm-5 col-xs-12">
              <font size="5" color="Green">
                Filter To:{' '}
              </font>
              <DateTimePicker
                name="endTimePicker"
                onChange={(date) => this.setState({ endTime: date })}
                value={this.state.endTime}
              />
            </div>
            <div className="col-sm-2 col-xs-12">
              <button
                type="button"
                className="btn fetchButton btn-success"
                onClick={this.queryData}
              >
                Fetch Data
              </button>
            </div>
          </div>
          <br />
          {this.state.usersList.length !== 0 && (
            <div>
              <div className="col-sm-6 col-xs-12">
                <select
                  name="selectedUser"
                  value={this.state.selectedUser}
                  className="form-control"
                  onChange={this.handleFilterChange}
                  selected={this.state.selectedUser}
                >
                  <option value="">All Users in this time range</option>
                  {Object.keys(this.state.usersList).map((user) => (
                    <option key={user} value={this.state.usersList[user]}>
                      {this.state.usersList[user]}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-6 col-xs-12">
                <select
                  name="selectedFridge"
                  value={this.state.selectedFridge}
                  className="form-control"
                  onChange={this.handleFilterChange}
                  selected={this.state.selectedFridge}
                >
                  <option value="">All Fridges in this time range</option>
                  {Object.keys(this.state.fridgeList).map((fridge) => (
                    <option key={fridge} value={this.state.fridgeList[fridge]}>
                      {this.state.fridgeList[fridge]}
                    </option>
                  ))}
                </select>
                <br />
              </div>
            </div>
          )}
          {this.state.isLoading && (
            <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              disabled=""
              type="submit"
              isLoading={this.state.isLoading}
              text=""
              loadingText="Loading Logs & Users…"
            />
          )}
          {this.state.logs.length === 0 && (
            <div className="NotFound">
              <h3>NO Data to Load</h3>
            </div>
          )}
          {this.state.logs.length !== 0 && (
            <table id="logTable">
              <tbody>
                <tr>
                  <th>User</th>
                  <th>Fridge</th>
                  <th>Operation</th>
                  <th>Request Time</th>
                  <th>Response Time</th>
                  <th>Error message</th>
                </tr>
                {this.state.filteredLogs.map(this.generateRows)}
              </tbody>
            </table>
          )}
        </div>
      </div>
    );
  }
}
